module.exports = __webpack_public_path__ + "img/pic-03.1994cf17.png";